import apiRequest from './apiRequest';

export type ExternalMotionSearchRequest = {
  pageSize: number;
  searchTerm?: string;
  searchAfter?: [number, string];
  category?: string;
  subcategory?: string;
  tags?: string[];
};

export type ExternalMotionSearchTagAggregation = {
  tag: string;
  docCount: number;
};

export type ExternalMotionSearchSubcategoryAggregation = {
  subcategory: string;
  docCount: number;
  tags: ExternalMotionSearchTagAggregation[];
};

export type ExternalMotionSearchCategoryAggregation = {
  category: string;
  docCount: number;
  subcategories: ExternalMotionSearchSubcategoryAggregation[];
};

export type ExternalMotionSearchResultItem = {
  motionID: string;
  title: string;
  short: string;
  tags: string[];
  categoryAndSubcategories: string[];
  mp4URL: string;
  gifURL: string;
};

export type ExternalMotionSearchResponse = {
  items: ExternalMotionSearchResultItem[];
  categoryInformation: ExternalMotionSearchCategoryAggregation[];
  total?: number;
  pageSize: number;
  hasMore: boolean;
  lastSort?: [number, string];
};

export default async function postExternalMotionSearch(
  apiKey: string,
  params: ExternalMotionSearchRequest,
  signal?: AbortSignal,
) {
  return await apiRequest<ExternalMotionSearchResponse>(
    'external-mogen',
    '/motion/search',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'x-api-key': apiKey,
      },
      body: JSON.stringify(params),
    },
    signal,
  );
}
